import NATIONS from "../../data/nations.json";
import PERSONART from "../enums/PERSONART";
import { capitalize } from "../functions";

export function mapNationality(nationalitaet) {
  let staatenlos = NATIONS.laenderuebersicht.find(x => x.Kurzbezeichnung === "STAA") || { Langbezeichnung: "keine" };
  if (isNaN(nationalitaet)) return staatenlos;
  let number = Number(nationalitaet);
  let nationality = NATIONS.laenderuebersicht.find(x => Number(x.Nationalität) === number) || staatenlos;
  nationality.Langbezeichnung = capitalize(nationality.Langbezeichnung);
  return nationality;
}

export function mapGebietsansaessigerKZ(gebietsansaessigKz) {
  if (Number(gebietsansaessigKz) === 0) return "Nein";
  if (Number(gebietsansaessigKz) === 1) return "Ja";
  return "";
}

export function mapPersonenart(personArt) {
  if (personArt === PERSONART.NATUERLICHE_PERSON.KUERZEL) {
    return PERSONART.NATUERLICHE_PERSON.BEZEICHNUNG;
  }
  if (personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL) {
    return PERSONART.JURISTISCHE_PERSON.BEZEICHNUNG;
  }
  if (personArt === PERSONART.WIRTSCHAFTLICHE_PERSON.KUERZEL) {
    return PERSONART.WIRTSCHAFTLICHE_PERSON.BEZEICHNUNG;
  }
  return "";
}
